import { render, staticRenderFns } from "./DataLayer.vue?vue&type=template&id=1615b524&"
import script from "./DataLayer.vue?vue&type=script&lang=js&"
export * from "./DataLayer.vue?vue&type=script&lang=js&"
import style0 from "./DataLayer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCardText,VSimpleTable})
